<template>
  <section id="course-log" class="py-3 grey lighten-3">
    <v-container grid-list-md style="max-width: 750px">
      <v-layout align-end row class="mb-2">
        <v-flex style="flex-shrink: 0;">
          <h2 class="display-1 mb-2">修課紀錄</h2>
          <h4 class="subheading">已修及格 {{ totalCredit }} 學分</h4>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn class="mr-0" color="primary" :loading="loading" @click="SET_IMPORT_DIALOG(true)">匯入</v-btn>
          <v-btn class="mr-0" color="secondary" :disabled="loading" @click="SET_COURSE_LOG([])">清空</v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="courseLog"
        rows-per-page-text="每頁筆數"
        no-data-text="請先匯入修課紀錄或使用範例紀錄"
        :loading="loading"
        disable-initial-sort
        class="elevation-1 mb-2">
        <template slot="items" slot-scope="props">
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.semester }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.no }}</td>
          <td>{{ props.item.name }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.credit }}</td>
          <td :class="{'red--text': props.item.isPassed === '未及格'}">{{ props.item.isPassed }}</td>
        </template>
      </v-data-table>
    </v-container>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { SET_IMPORT_DIALOG, SET_COURSE_LOG } from '../store/constants';

const headers = [
  {
    text: '學年學期',
    value: 'semester'
  },
  {
    text: '科號',
    value: 'number'
  },
  {
    text: '科目名稱',
    sortable: false,
    value: 'name'
  },
  {
    text: '學分',
    sortable: false,
    value: 'credit'
  },
  {
    text: '是否及格',
    sortable: false,
    value: 'isPassed'
  },
];

export default {
  name: 'course-log',
  computed: {
    ...mapGetters(['courseLog', 'loading']),
    totalCredit() {
      return this.courseLog.reduce((acc, cur) => cur.isPassed === '及格' ? acc + parseInt(cur.credit) : acc, 0);
    },
    headers() {
      return this.$vuetify.breakpoint.xs ? [headers[2], headers[4]] : headers;
    },
  },
  methods: {
    ...mapActions([SET_IMPORT_DIALOG, SET_COURSE_LOG]),
  }
}
</script>
